function hasCookie(name, value) {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(name + "=")) {
      const cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
      if (cookieValue === value) {
        return true;
      }
    }
  }
  return false;
}

function applyHighContrast() {
  var allElements = document.querySelectorAll('*:not(.acoes)');
  for (var i = 0; i < allElements.length; i++) {
    var currentElement = allElements[i];
    currentElement.style.backgroundColor = 'black';
    currentElement.setAttribute('style', currentElement.getAttribute('style') + ' color: yellow !important;');
    var computedStyle = window.getComputedStyle(currentElement);
    if (computedStyle.border != '0px none rgb(255, 255, 0)') {
      currentElement.style.border = '1px solid white';
    }
    currentElement.setAttribute('style', currentElement.getAttribute('style') + ' background-color: black !important;');
  }
  document.querySelectorAll('img[alt*="Acesso rápido"], img[alt*="Acesso do Aluno"]').forEach((el)=>{el.style.filter = 'invert(1) hue-rotate(20deg) saturate(10.5)';})
  var allImgs = document.querySelectorAll('img, #banner .container, #banner .title, #banner .title *, .curso-info.ad,.curso-info.ad *, .mi.current-page__icon-closed, #scroll-header .container, #scroll-header .container .right');
  for (var i = 0; i < allImgs.length; i++) {
    var currentElement = allImgs[i];
    currentElement.style.backgroundColor = '';
    currentElement.style.color = '';
  }
  document.body.style.filter = "none";
}

const hasContrast = hasCookie("a11y_contrast", "true");
document.querySelector('#a11y-contrast-button').addEventListener('click', (e) => {
  setTimeout(() => {
    if (hasCookie("a11y_contrast", "true")) {
      applyHighContrast()

    } else {
      var allElements = document.getElementsByTagName('*');
      for (var i = 0; i < allElements.length; i++) {
        var currentElement = allElements[i];
        currentElement.style.backgroundColor = '';
        currentElement.style.color = '';
        currentElement.style.border = '';
        document.querySelectorAll('img[alt*="Acesso rápido"], img[alt*="Acesso do Aluno"]').forEach((el)=>{el.style.filter = '';})
      }
    }
  }, 70)

});
if (hasContrast) {
  document.addEventListener('DOMContentLoaded',()=>{
    setTimeout(() => {
    applyHighContrast()
    }, 70)
  })
}
